import React from "react";
import { Link } from "react-router-dom";
import "./ChineseSubject.css";

export default function ChineseSubject() {
  return (
    <div className="play2learn-ChineseSubject">
      <h1 className="ChineseSubject-title">Chinese Subject Lessons</h1>
      <p className="ChineseSubject-description">
        Choose your preferred phonetic system:
      </p>

      <div className="ChineseSubject-grade-container">
        <Link to="/ChineseSubject/Zhuyin" className="ChineseSubject-grade-card">
          Zhuyin
        </Link>
        <Link to="/ChineseSubject/Pinyin" className="ChineseSubject-grade-card">
          Pinyin
        </Link>
      </div>
    </div>
  );
}
